export default __webpack_public_path__ + "static/media/IMG-20240822-WA0022.925867e0.jpg";